import { useSelector } from 'react-redux'
import { selectDepotMapStyles } from '@/features/domain/ui'

export const useDepotsMapStyle = () => {
  const { mode, custom } = useSelector(selectDepotMapStyles)

  if (Object.keys(custom).length > 0) return

  return mode
}
